/**
 * Internal dependencies
 */
import { applyEdits } from 'state/utils';
import isEditedPaymentTypeDirty from './is-edited-payment-type-dirty';
import getConnectionPaymentType from './get-connection-payment-type';
import getEdits from './get-edits';

export default (state, id) => {

    id = !id ? "" : id;

    if (isEditedPaymentTypeDirty(state, id || "")) {
        let connectionPaymentTypes = getConnectionPaymentType(state, id);
        let edits = getEdits(state, id);
        connectionPaymentTypes = applyEdits(connectionPaymentTypes, edits);
        return connectionPaymentTypes;
    }

    return getConnectionPaymentType(state, id);
};